const reportWebVitals = (onPerfEntry?: any): void => {
  if (onPerfEntry && typeof onPerfEntry === 'function') {
    import('web-vitals')
      .then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
        getCLS(onPerfEntry);
        getFID(onPerfEntry);
        getFCP(onPerfEntry);
        getLCP(onPerfEntry);
        getTTFB(onPerfEntry);
      })
      .catch(() => {
        // Non-critical analytics import: swallow failures so a stale/blocked
        // web-vitals chunk never reaches the global stale-chunk reload net
        // (installStaleChunkGuard) and force-reloads the app.
      });
  }
};

export default reportWebVitals;
